import { useEffect, useState } from "react"

export const Loader = () => {
  const [dots, setDots] = useState(1)

  useEffect(() => {
    const timerId = setInterval(() => setDots((dots) => (dots + 1) % 4), 1e3)
    return () => clearInterval(timerId)
  }, [])

  return (
    <div
      role="status"
      aria-label="Loading"
      className="flex h-screen w-screen flex-col items-center justify-center gap-4 bg-base-100"
    >
      <div className="aspect-square h-[25px] w-[25px] animate-spin bg-base-content [animation-duration:2s]" />
      <span className="tracking-wider text-base-content">Loading{new Array(dots).fill(".")}</span>
    </div>
  )
}
